import React from "react";
import "./MoveChargesCard.scss"
import { MovePaperWorkCard } from "components/movePaperWorkCard";
import { MoveListCard } from "components/moveListCard";
import { Button } from "components/button";
import { EstimatorDetailCard } from "components/estimatorDetailCard";
import { OrignCompanyDetailCard } from "components/OrignCompanyDetailCard";
import { CompanyDetailCard } from "components/companyDetailCard";
import { DestinationCompanyDetailCard } from "components/DestinationCompanyDetailCard";
import { InfoCard } from "components/infoCard";
import { CardLayout } from "components/cardLayout";
import { getEstFlowEstimateDetails, getEstimatorInventory } from "../../core/services/moveDetailsByCustomer"
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'
//@ts-ignore
// import SimpleLineIcon from 'react-simple-line-icons';
// import '../../../node_modules/font-awesome/css/font-awesome.min.css'
import { MdClose } from "react-icons/md";
//@ts-ignore
import SignatureCanvas from 'react-signature-canvas'
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { client } from "App";
import { saveSignatures } from '../../core/services/saveSignatures'
import { navigate } from "@reach/router";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Spinner from '../spinner/spinner';
//import { sign } from "crypto";

export interface MoveChargesCardProps {

}

export interface MoveChargesCardState {
    loading: boolean
    data: any
    responseEstDetail: any

}
class MoveChargesCard extends React.Component<MoveChargesCardProps, MoveChargesCardState> {
    private _isMounted: boolean = false
    sigCanvasFirst: any;
    sigCanvasSecond: any;
    firstSignPadRef: any;

    constructor(props: MoveChargesCardProps) {
        super(props);
        //debugger;

        this.state = {
            loading: true,
            responseEstDetail: [],
            data: {
                w: "$6500 lbs",
                m: "750 mi"
            }
        };


    }


    componentDidMount() {

        console.log("componentDidMount")

        //this.setState({loading:false});
        this._isMounted = true;
        var cid = (localStorage.getItem("CID") || "");
        var securetoken = localStorage.getItem("securetoken") || "";
        //this.getData(cid);
        Promise.all([
            //this.getCustomerDetails(cid),
            this.getEstFlowEstimateDetails(cid),
            this.getEstimatorInventory(cid)
        ]).then((response: any[]) => {
            if (this._isMounted) {
                const responseEstDetail = response[0][0];
                console.log("RESPONSEEEEEEEEEEE", responseEstDetail)
                this.setState({ responseEstDetail: responseEstDetail, loading: false });
            }
        });

    }

    componentWillUnmount() {
        this._isMounted = false;
        console.log("componentWillUnmount")
    }

    async getCustomerDetails(cid: string, securetoken: string) {
        return await getCustomerDetails(cid, securetoken)
    }

    async getEstFlowEstimateDetails(cid: string) {
        return await getEstFlowEstimateDetails(cid)
    }

    async getEstimatorInventory(cid: string) {
        return await getEstimatorInventory(cid)
    }




    render() {


        return (
            this.state.loading ? <Spinner /> :
                <CardLayout>

                    <div className="headContent">
                        <div className={"listItemNoBaground"}>
                            <p>Weight:</p>
                            <h3><span>{parseFloat(this.state.responseEstDetail.weight||0).toLocaleString(undefined, {})} lbs</span></h3>
                        </div>
                        <div className={"listItemNoBaground"}>
                            <p>Total Miles:</p>
                            <h3><span>{parseFloat(this.state.responseEstDetail.miles||0).toLocaleString(undefined, {})} mi</span></h3>
                        </div>
                    </div>



                </CardLayout>
        );
    }
}

export default MoveChargesCard;